import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZa = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-za",
	viewBox: "0 0 640 480",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fillOpacity: .7,
			d: "M-71.9 0h682.7v512H-71.9z"
		})
	}) }), /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		transform: "translate(67.4) scale(.93748)",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "evenodd",
			strokeWidth: "1pt",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M-71.9 407.8V104.4L154 256.1-72 407.8z" }),
				/* @__PURE__ */ _jsx("path", {
					fill: "#000c8a",
					d: "m82.2 512.1 253.6-170.6H696V512H82.2z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#e1392d",
					d: "M66 0h630v170.8H335.7S69.3-1.7 66 0z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#ffb915",
					d: "M-71.9 64v40.4L154 256-72 407.8v40.3l284.5-192L-72 64z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#007847",
					d: "M-71.9 64V0h95l301.2 204h371.8v104.2H324.3L23 512h-94.9v-63.9l284.4-192L-71.8 64z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M23 0h59.2l253.6 170.7H696V204H324.3L23 .1zm0 512.1h59.2l253.6-170.6H696v-33.2H324.3L23 512z"
				})
			]
		})
	})]
});
export default SvgZa;
